/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/coins_2'
export default icon
